import { memo } from 'react';
import { Flex } from '@chakra-ui/react';

const Tag = ({ children, ...props }) => (
  <Flex
    as="p"
    boxSizing="border-box"
    w="fit-content"
    borderRadius="100px"
    borderWidth={{ laptop: '1.6px', mobile: '1px' }}
    borderStyle="solid"
    borderColor="bg.black"
    textStyle="tag"
    align="center"
    textAlign="center"
    p={{ mobile: '7px 12px', laptop: '8px 16px' }}
    transition="color .2s, background-color .2s"
    {...props}
  >
    {children}
  </Flex>
);

export default memo(Tag);
